import angular from 'angular'

// components
import tableSearchPrompt from './component/tableSearchPrompt.js'

export default angular
  .module('portalApp.tableSearchPrompt', [])
  .component('tableSearchPrompt', tableSearchPrompt)
  .name
